import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="rules";

export function selectAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectOneByMenuName(parameter){
  console.log("menuName:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectOneByMenuName/${parameter}`,
    method: 'get'
  })
}

export function deleteObj(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}


export default {
  selectAll,
  delete:deleteObj,
  save:insert,
  update,
  selectOne:selectOneByMenuName
}